import { createApp } from 'vue'
import App from './App.vue'
import { library} from '@fortawesome/fontawesome-svg-core'
import { fas} from '@fortawesome/free-solid-svg-icons'
import "./db.js";
        library.add(fas )

createApp(App).mount('#app')
